<template>
  <div class="container section">
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-default panel-table">
          <div class="panel-body">
            <app-datatable></app-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "./Datatable.vue";
export default {
  components: {
    "app-datatable": Datatable
  }
};
</script>
<style lang="scss">
#app {
  .dropdown-menu {
    &.dt-button-collection {
      padding: 0;
      max-height: 70vh;
      overflow-x: hidden;
      .dropdown-item {
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: capitalize;
        white-space: nowrap;
        padding: 0.7em 0.7em;
        max-width: 130px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue